"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeHttpAdapter = void 0;
const FakeChatAdapter_1 = require("./FakeChatAdapter");
const FakeMessageAdapter_1 = require("./FakeMessageAdapter");
const FakeStarredMessageAdapter_1 = require("./FakeStarredMessageAdapter");
const FakeUserDirectoryAdapter_1 = require("./FakeUserDirectoryAdapter");
/* eslint-disable @typescript-eslint/no-unused-vars */
class FakeHttpAdapter {
    constructor() {
        this.starredMessageAdapter = new FakeStarredMessageAdapter_1.FakeStarredMessageAdapter();
        this.chatAdapter = new FakeChatAdapter_1.FakeChatAdapter();
        this.userDirectoryAdapter = new FakeUserDirectoryAdapter_1.FakeUserDirectoryAdapter();
        this.messageAdapter = new FakeMessageAdapter_1.FakeMessageAdapter();
    }
    getEMRAdapter() {
        throw new Error("Method not implemented.");
    }
    getLabsAdapter() {
        throw new Error("Method not implemented.");
    }
    getSyncQueueAdapter() {
        throw new Error("Method not implemented.");
    }
    uploadFile(url, stream, contentSize) {
        throw new Error("Method not implemented.");
    }
    withChatAdapter(chatAdapter) {
        this.chatAdapter = chatAdapter;
        return this;
    }
    delete(url, options) {
        return Promise.resolve(undefined);
    }
    get(url, options) {
        return Promise.resolve(undefined);
    }
    getAlertAdapter() {
        throw new Error("Method not implemented.");
    }
    getChatAdapter() {
        return this.chatAdapter;
    }
    getCommonAdapter() {
        throw new Error("Method not implemented.");
    }
    getMessageAdapter() {
        return this.messageAdapter;
    }
    getOrganizationAdapter() {
        throw new Error("Method not implemented.");
    }
    getUserDirectoryAdapter() {
        return this.userDirectoryAdapter;
    }
    post(url, data, options) {
        return Promise.resolve(undefined);
    }
    put(url, data, options) {
        return Promise.resolve(undefined);
    }
    getStarredMessageAdapter() {
        return this.starredMessageAdapter;
    }
    patch(url, data, options) {
        return Promise.resolve(undefined);
    }
}
exports.FakeHttpAdapter = FakeHttpAdapter;
